import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20composition%20with%20deep%20forest%20green%20and%20charcoal%20black%20gradients%2C%20mysterious%20and%20dramatic%20atmosphere%2C%20subtle%20geometric%20patterns%20floating%20like%20whispers%2C%20editorial%20design%20background%20with%20cinematic%20depth%2C%20dark%20elegant%20aesthetic%20with%20soft%20light%20leaks%20in%20warm%20amber%20and%20copper%20tones%2C%20no%20text%20no%20people%20just%20pure%20abstract%20visual%20texture&width=1600&height=900&seq=hero-bg-51fun-v1&orientation=landscape"
          alt="51fun吃瓜黑料不打烊 - 吃瓜黑料在线吃瓜"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-fire-line text-accent-400 text-xs"></i>
            </div>
            <span className="text-accent-300 text-xs font-medium whitespace-nowrap">24小时吃瓜不打烊</span>
          </div>

          <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-background-50 mb-4 leading-tight">
            黑料吃瓜
          </h1>

          <p className="text-background-50/70 text-sm md:text-base max-w-xl mx-auto mb-8 leading-relaxed">
            51fun吃瓜黑料不打烊，实时追踪网红翻车、明星八卦。吃瓜黑料今日吃瓜热点全覆盖，海量黑料资源等你探索！
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/heiliao-baoliao"
              className="whitespace-nowrap cursor-pointer px-8 py-3 rounded-full bg-accent-500 text-background-50 font-medium text-sm hover:bg-accent-600 transition-all"
            >
              立即吃瓜
              <div className="w-4 h-4 inline-flex items-center justify-center ml-1">
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap cursor-pointer px-8 py-3 rounded-full border border-background-50/30 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-all"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom slogan */}
      <div className="absolute bottom-0 left-0 right-0 pb-8 md:pb-12 pointer-events-none">
        <p className="text-center text-background-50/15 font-heading font-bold text-3xl md:text-5xl lg:text-7xl whitespace-nowrap tracking-wider">
          吃瓜黑料不打烊
        </p>
      </div>
    </section>
  );
}
